import { store } from '../../store';
import subscribeToCoreUpdates from '../core_updates_channel';
import { subscribeQueues } from '../../ReduxSlices/Prescriptions/prescriptionQueueSlice';


let unsubscribePrescriptionQueue = null;

export const initializePrescriptionQueueSubscription = () => {
  if (unsubscribePrescriptionQueue) return;

  unsubscribePrescriptionQueue = subscribeToCoreUpdates("prescriptionQueue", {
    
    "prescription_queue.created": (queue) => {
      store.dispatch(subscribeQueues({ action: "created", queue }));
    },

    "prescription_queue.updated": (queue) => {
      store.dispatch(subscribeQueues({ action: "updated", queue }));
    },

    "prescription_queue.deleted": (queue) => {
      store.dispatch(subscribeQueues({ action: "deleted", queue }));
    }

  });

  //console.log("✅ PrescriptionQueue subscription initialized");
};

export function unsubscribePrescriptionQueueSubscription() {
  if (unsubscribePrescriptionQueue) {
    unsubscribePrescriptionQueue(); // remove only PrescriptionQueue handlers
    unsubscribePrescriptionQueue = null;
    //console.log("🔌 PrescriptionQueue subscription removed");
  }
}